import { SocietyUserVar } from "@dune/types";
import { Button, DataTable, Toaster } from "@dune/ui";
import { Plus, User01 } from "@untitled-ui/icons-react";
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useGetBrokerUsers } from "../../../../../api/queries/societies.queries";
import { useMe } from "../../../../../api/queries/users.queries";
import { AddUserDialog } from "./usersTabFiles/AddUserDialog";
import { EditUserDialog } from "./usersTabFiles/EditUserDialog";
import { SetSignatoryDialog } from "./usersTabFiles/SetManagerDialog";
import { SuspendUserDialog } from "./usersTabFiles/SuspendUserDialog";
import { userFromBrokerColumns } from "./usersTabFiles/userFromBrokerColumns";

const UsersTab: React.FC = () => {
	const { id } = useParams<{ id: string }>();
	const { data: users, isLoading } = useGetBrokerUsers(Number(id));
	const { me } = useMe();

	const canSetManager = me?.subrole === "BROKER_ADMIN" || me?.role === "DUNE";
	const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
	const [editingUser, setEditingUser] = useState<SocietyUserVar | null>(null);
	const [suspendingUser, setSuspendingUser] = useState<SocietyUserVar | null>(
		null,
	);
	const [settingManagerUser, setSettingManagerUser] =
		useState<SocietyUserVar | null>(null);

	return (
		<>
			<div className="flex flex-col gap-4">
				<div className="flex flex-row justify-between gap-4 pb-3 w-full">
					<div className="text-text-main-blue font-semibold">
						Liste des utilisateurs
					</div>
					<Button onClick={() => setIsAddDialogOpen(true)}>
						<Plus /> Ajouter un utilisateur
					</Button>
				</div>
				<DataTable
					columns={userFromBrokerColumns({
						onEdit: setEditingUser,
						onSuspend: setSuspendingUser,
						onSetManager: setSettingManagerUser,
						canSetManager,
					})}
					data={users || []}
					noResultsText="Aucun utilisateur trouvé"
					icon={User01}
					variant="static-clean"
					isLoading={isLoading}
				/>
			</div>

			<AddUserDialog
				isOpen={isAddDialogOpen}
				onClose={() => setIsAddDialogOpen(false)}
				societyId={Number(id)}
			/>

			{editingUser && (
				<EditUserDialog
					open={!!editingUser}
					onOpenChange={(open) => !open && setEditingUser(null)}
					user={editingUser}
				/>
			)}

			{suspendingUser && (
				<SuspendUserDialog
					open={!!suspendingUser}
					onOpenChange={(open) => !open && setSuspendingUser(null)}
					user={suspendingUser}
				/>
			)}

			{settingManagerUser && (
				<SetSignatoryDialog
					open={!!settingManagerUser}
					onOpenChange={(open: boolean) => !open && setSettingManagerUser(null)}
					user={settingManagerUser}
				/>
			)}
			<Toaster />
		</>
	);
};

export default UsersTab;
